// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LifestyleChoiceDetails_wrapper__XZF8T","inner":"LifestyleChoiceDetails_inner__2axCi"};